import useQueryParams from './useQueryParams'

export default function useMetasearchAccountType(): string | undefined {
  const query = useQueryParams()

  return query.get('accountType') ?? undefined
}
